import { Link } from 'react-router-dom';
import { Card } from '../components/Card';
import { EmptyState } from '../components/EmptyState';

/** Fallback screen for unknown routes inside the authenticated shell. */
export function NotFound(): JSX.Element {
  return (
    <div className="mx-auto w-full max-w-2xl">
      <Card>
        <EmptyState
          title="Page not found"
          description="The page you were looking for doesn't exist or has moved."
          action={
            <Link
              to="/"
              className="inline-flex items-center rounded-md bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500"
            >
              Back to Dashboard
            </Link>
          }
        />
      </Card>
    </div>
  );
}
